//TODO: DONE! SET_LOADING, SET_CONTACT,
// CONTACT_TO_UPDATE, SET_SINGLE_CONTACT

export const SET_LOADING = "SET_LOADING";
export const SET_CONTACT = "SET_CONTACT";
export const CONTACT_TO_UPDATE = "CONTACT_TO_UPDATE";
export const SET_SINGLE_CONTACT = "SET_SINGLE_CONTACT";
